export default {
  auto: 'Auto Detect',
  zh: 'Chinese',
  en: 'English',
  ja: 'Japanese',
  ko: 'Korean',
  fr: 'French',
  de: 'German',
  ru: 'Russian',
  pt: 'Portuguese',
  es: 'Spanish',
  ar: 'Arabic',
  th: 'Thai',
  it: 'Italian',
  tr: 'Turkish',
  vi: 'Vietnamese',
  pl: 'Polish',
  he: 'Hebrew',
  id: 'Indonesian',
  hi: 'Hindi',
  nl: 'Dutch',
  ms: 'Malay',
  bn: 'Bengali',
  ur: 'Urdu',
  fa: 'Persian',
  cs: 'Czech',
  km: 'Khmer',
  lo: 'Lao',
  my: 'Myanmar',
  ceb: 'Cebuano',
  fil: 'Filipino',
  yue: 'Cantonese',

  translating: 'Translating...',
  showSource: 'Show Source',
  reTranslate: 'Retranslate',
  pageTranslate: 'Page Translation',
  paragraphCompare: 'Paragraph Compare',
  aliTranslate: 'AliTranslate',
  source: 'Source',
  target: 'Target',
  paragraphLoading: 'Translating Paragraph...',
} as const;
